import {Component} from '@angular/core';
import {ViewController, NavParams} from 'ionic-angular';
import {IEmployee} from '../../../../../services/employee.service';

@Component({
    template: `
        <ion-list>
            <ion-list-header color="dark">Employees</ion-list-header>
            <button ion-button full color="light" *ngFor="let x of employeeList" (click)="selectItem(x)">{{x.lastname + ", " + x.firstname}}</button>
        </ion-list>
    `,
})
export class LaborPopover {

    // Declare our preset title list
    private employeeList : IEmployee[];

    constructor( 
        public viewCtrl : ViewController,
    ) {
        // Assign our title list to our preset list
        let navParams : NavParams = this.viewCtrl.getNavParams();
        this.employeeList = navParams.get("employeeList");
    }
    
    selectItem(item : IEmployee) {
        this.viewCtrl.dismiss({
            selected: item
        });
    }
}
    


// WEBPACK FOOTER //
// ./src/pages/report/tab-main/labor/labor-popover/labor-popover.component.ts